import "./Header.scss";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import Logo from "../assets/images/logoTellMeMore_hy1qcb_agqhbt.svg";
import Button from "./Button";

function Header() {
  const navigate = useNavigate();

  // function to go to back office depending of registered user
  const backoffice = () => {
    if (Cookies.get("status") === undefined) {
      navigate("/backoffice/login");
    } else {
      navigate("/backoffice");
    }
  };
  // function for deconnexion
  const deconnexion = () => {
    Cookies.remove("status");
    navigate("/");
  };
  return (
    <div className={"headerContainer"}>
      <img
        src={Logo}
        className="logo"
        alt="LogoTellMeMore"
        onClick={() => {
          navigate("/");
        }}
      />
      <div className="headerButtons">
        <Button
          text={"Backoffice"}
          color={"green"}
          func={backoffice}
          show={Cookies.get("status") === undefined ? true : false}
        />
        <Button
          text={"Déconnexion"}
          color={"red"}
          func={deconnexion}
          show={Cookies.get("status") === undefined ? false : true}
        />
      </div>
    </div>
  );
}

export default Header;
